<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>
        {{ editing ? 'Edit table details' : 'New table details' }}
      </v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-form v-model="table_form" ref="table_form">
        <v-text-field
            label="Table Name"
            v-model="item.name"
            :rules="[rules.required]"
        />
        <v-text-field
            label="Min Stake"
            v-model="item.min_stake"
            type="number"
            :rules="[rules.required]"
        />
        <v-select
            v-model="item.image"
            :items="images"
            label="Select Image"
            item-text="image"
        >
          <template v-slot:item="slotProps">
            <img
                :src="`${$store.getters.apiDomain}${slotProps.item.link}`"
                style="height: 50px; width: 50px; margin-right: 20px; margin-bottom: 2px"
                alt="img"
            />
            {{slotProps.item.image }}
          </template>
        </v-select>
        <v-text-field
            label="Event Date"
            v-model="item.event_datetime"
            type="date"
            :rules="[rules.required]"
        />
        <v-text-field
            label="Event Time"
            v-model="time"
            type="time"
            :rules="[rules.required]"
        />
        <v-select
            label="Status"
            v-model="item.status"
            :items="status_options"
            :rules="[rules.required]"
        />
      </v-form>
      <v-card-actions>
        <v-row>
          <v-spacer/>
          <v-btn @click="$emit('close')">Cancel</v-btn>
          <v-btn v-if="!editing" color="success" @click="newTable" :loading="loading">Create</v-btn>
          <v-btn v-else color="success" @click="editTable" :loading="loading">Edit</v-btn>
        </v-row>
      </v-card-actions>
    </v-container>

  </v-card>
</template>

<script>
import tableStatusOptions from "@/helpers";

export default {
  name: "TableForm",
  props: {
    editing: Boolean,
    table: {
      required: true,
      default: {
        name: String,
        event_datetime: String,
        status: String,
        min_stake: Number,
        players: {
          default: () => []
        },
        waiting_list: {
          default: () => []
        },
      }
    }
  },
  data() {
    return {
      item: {
        name: '',
        image: '',
        event_datetime: '',
        status: '',
        players: [],
        min_stake: 0,
        waiting_list: [],
      },
      images: [
        { image: '1.jpg', link: '/public/assets/images/1.jpg' },
        { image: '2.jpg', link: '/public/assets/images/2.jpg' },
        { image: '3.jpg', link: '/public/assets/images/3.jpg' },
        { image: '4.jpg', link: '/public/assets/images/4.jpg' }
      ],
      time: '',
      status_options: tableStatusOptions(),
      loading: false,
      table_form: false,
      rules: {
        required: v => !!v || 'Required Field'
      }
    }
  },
  computed: {
  },
  methods: {
    async newTable() {
      if (this.$refs.table_form.validate()) {
        this.loading = !this.loading
        this.item.event_datetime += ` ${this.time}`
        await this.$store.dispatch('NEW_TABLE', this.item)
        this.loading = !this.loading
      }
    },
    async editTable() {
      if (this.$refs.table_form.validate()) {
        this.loading = !this.loading
        this.item.event_datetime += ` ${this.time}`
        this.item.min_stake = parseFloat(this.item.min_stake.toString())
        await this.$store.dispatch('EDIT_TABLE', this.item)
        this.loading = !this.loading
      }
    }
  },
  created() {
    if (this.$props.table) {
      this.item = this.$props.table
      const splitDateTime = this.item.event_datetime.split('T')
      if (splitDateTime.length === 2) {
        this.item.event_datetime = splitDateTime[0]
        this.time = splitDateTime[1].substring(0, 5)
      }
    }
  }
}
</script>

<style scoped>

</style>